import React from "react";

type SectionHeaderProps = {
  title: string;
  description?: string;
  action?: React.ReactNode;
};

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  description,
  action,
}) => {
  return (
    <div className="data-lite-section-header">
      <div>
        <h2 className="data-lite-section-title">{title}</h2>
        {description && (
          <p className="data-lite-section-description">{description}</p>
        )}
      </div>
      {action && <div className="data-lite-section-action">{action}</div>}
    </div>
  );
};

export default SectionHeader;
